var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeeRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1359 3.24709C14.9044 2.19758 13.093 2.19759 11.8616 3.24708L10.381 4.50879C10.2051 4.6587 9.98635 4.74929 9.75596 4.76767L7.8169 4.92241C6.20398 5.05113 4.9232 6.33191 4.79449 7.94482L4.63975 9.88388C4.62138 10.1143 4.53076 10.333 4.38085 10.5089L3.11914 11.9895C2.06965 13.221 2.06966 15.0323 3.11916 16.2637L4.38087 17.7444C4.53076 17.9203 4.62136 18.139 4.63974 18.3694L4.79451 20.3084C4.92322 21.9213 6.20401 23.202 7.81694 23.3307L9.75597 23.4856C9.98635 23.5039 10.205 23.5946 10.3809 23.7445L11.8615 25.0061C13.093 26.0556 14.9044 26.0557 16.1359 25.0061L17.6164 23.7445C17.7923 23.5946 18.011 23.5039 18.2414 23.4855L20.1805 23.3307C21.7933 23.2021 23.0741 21.9214 23.2029 20.3084L23.3576 18.3694C23.3759 18.139 23.4666 17.9202 23.6164 17.7442L24.8782 16.2638C25.9278 15.0323 25.9278 13.2209 24.8782 11.9895L23.6164 10.5089C23.4665 10.333 23.376 10.1143 23.3577 9.88389L23.2029 7.94483C23.0742 6.33193 21.7933 5.0511 20.1805 4.9224L18.2414 4.76766C18.011 4.74927 17.7923 4.6587 17.6164 4.50879L16.1359 3.24709ZM17.1049 9.46695L18.6582 11.0202L10.8919 18.7866L9.33862 17.2332L17.1049 9.46695ZM12.0569 12.1851C11.4134 12.8285 10.3703 12.8285 9.72693 12.1851C9.08355 11.5418 9.08355 10.4987 9.72693 9.85527C10.3703 9.21188 11.4134 9.21188 12.0569 9.85527C12.7002 10.4987 12.7002 11.5418 12.0569 12.1851ZM15.94 18.3982C15.2966 17.7548 15.2966 16.7117 15.94 16.0683C16.5834 15.4249 17.6264 15.4249 18.2698 16.0683C18.9132 16.7117 18.9132 17.7548 18.2698 18.3982C17.6264 19.0416 16.5834 19.0416 15.94 18.3982Z",
    fill: "url(#paint0_linear_47537_77313)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47537_77313",
    x1: 13.9987,
    y1: 2.45996,
    x2: 13.9987,
    y2: 39.2695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeRate);
export default __webpack_public_path__ + "static/media/FeeRate.22c147eeb5578b6c0f9225a028b285f3.svg";
export { ForwardRef as ReactComponent };